//data visualisation in pie chart
const birthdayEls = new Date(1998, 12, 30);
const birthdayDerre = new Date(2002, 3, 28);
const birthdayMichiel = new Date(2002, 11, 10);
const ctx = document.getElementById('dataVisual');
// eslint-disable-next-line no-new
new Chart(ctx, {
    type: 'pie',
    data: {
        labels: ['Facebook', 'Instagram', 'Twitter', 'Snapchat', 'Discord'],
        datasets: [
            {
                data: [3230000000, 1160000000, 356000000, 238000000, 140000000],
                backgroundColor: ['#3B5998', '#DD2A7B', '#00ACEE', '#FFFC00', '#7289DA'],
            },
        ],
    },
});

//calculate ages
function calculateAge(birthday) {
    const diffrenceDates = Date.now() - birthday.getTime();
    const age = new Date(diffrenceDates);

    return Math.abs(age.getUTCFullYear() - 1970);
}

document.getElementById('ageEls').textContent = calculateAge(birthdayEls).toString();
document.getElementById('ageDerre').textContent = calculateAge(birthdayDerre).toString();
document.getElementById('ageMichiel').textContent = calculateAge(birthdayMichiel).toString();
